import React, { useState, useCallback } from 'react';
import { Wand2, Sparkles } from 'lucide-react';
import AiAssistantPanel from './AiAssistantPanel';

/**
 * Floating gold launcher button + connected AI Assistant Panel.
 * Drop this once inside an admin layout — it stays bottom-right.
 *
 * Props:
 *  - pageContext (string)
 *  - currentData (object)
 *  - onApplySuggestion (fn) — optional. If provided, suggestion cards become applyable.
 */
export default function AiAssistantLauncher({
  pageContext = 'Admin Panel',
  currentData = {},
  onApplySuggestion,
}) {
  const [open, setOpen] = useState(false);
  const handleApply = useCallback((s) => onApplySuggestion?.(s), [onApplySuggestion]);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label="Open AI Design Assistant"
        title="Open AI Design Assistant"
        className="fixed bottom-5 right-5 z-40 group h-14 px-5 inline-flex items-center gap-2 rounded-full bg-ink text-white font-semibold shadow-[0_15px_40px_-10px_rgba(212,164,55,0.55)] border-2 border-[color:var(--kc-gold)] hover:bg-[color:var(--kc-gold)] hover:text-black transition-all"
        data-testid="ai-assistant-launcher"
      >
        <span className="relative inline-flex items-center justify-center w-7 h-7 rounded-full bg-[color:var(--kc-gold)] text-black group-hover:bg-black group-hover:text-[color:var(--kc-gold)] transition-colors">
          <Wand2 size={14} />
          <Sparkles size={10} className="absolute -top-1 -right-1 text-[color:var(--kc-gold)] group-hover:text-black animate-pulse" />
        </span>
        <span className="hidden sm:inline text-sm uppercase tracking-wider">AI Assistant</span>
      </button>
      <AiAssistantPanel
        open={open}
        onOpenChange={setOpen}
        pageContext={pageContext}
        currentData={currentData}
        onApplySuggestion={handleApply}
      />
    </>
  );
}
